export const EndoscopyRoute = [
  {
    path: '/endoscopy',
    component: () => import('./views/index')
  },
  {
    path: '/endoscopy/info',
    component: () => import('./views/info')
  },
  {
    path: '/endoscopy/news',
    component: () => import('./views/news')
  },
  {
    path: '/endoscopy/news/type',
    component: () => import('./views/news/type')
  },
  {
    path: '/endoscopy/news/search',
    component: () => import('./views/news/search')
  },
  {
    path: '/endoscopy/list',
    meta: {title: '检查状态'},
    component: () => import('./views/list')
  },
  {
    path: '/endoscopy/docs',
    meta: {title: '护理咨询'},
    component: () => import('./views/docs.vue')
  },
  {
    path: '/endoscopy/detail',
    meta: {title: '检查状态'},
    component: () => import('./views/detail')
  },
  {
    path: '/endoscopy/follow',
    meta: {title: '我的随访'},
    component: () => import('./views/follow')
  }
]



// WEBPACK FOOTER //
// ./src/page/endoscopy/route.js